module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 16);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 16:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANNEL_TYPE", function() { return CHANNEL_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STATUS", function() { return STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ITEM_STATUS", function() { return ITEM_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIGN_TYPE", function() { return SIGN_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "convertStatus", function() { return convertStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "convertSignType", function() { return convertSignType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "convertChannelStatus", function() { return convertChannelStatus; });
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17);
/* harmony import */ var core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_index_of__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1__);



var _STATUS, _SIGN_TYPE_TEXT;

var STATUS = (_STATUS = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_STATUS, '2', '已驳回'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_STATUS, '3', '待审核'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_STATUS, '5', '待机构审核'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_STATUS, '6', '机构已驳回'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_STATUS, '8', '销户'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_STATUS, '10', '已开户'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_STATUS, '11', '失败'), _STATUS);
var STATUS_AUDITED = [3, 5];
var STATUS_SUCCESS = [10];
var STATUS_REJECT = [2, 6, 11];
var STATUS_UNSIGN = [8];
var CHANNEL_TYPE = {
  //招商银行
  cmb: 10,
  //票据支付
  piaoju: 11,
  //汇付天下支付(B2B网关支付)
  huifu: 13,
  //财付通买家
  tenpayBuyer: 15,
  //财付通卖家
  tenpaySeller: 16
};
var ITEM_STATUS = {
  success: 'success',
  reject: 'reject',
  audited: 'audited',
  //已解约成功(目前只有票据有解约)
  unsign: 'unsign',
  //待验证(财付通商家收款，机构审核状态下判断子状态)
  verify: 'verify'
};
var SIGN_TYPE = {
  sign: 1,
  unsign: 2
};
var SIGN_TYPE_TEXT = (_SIGN_TYPE_TEXT = {}, _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_SIGN_TYPE_TEXT, '1', '签约'), _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_1___default()(_SIGN_TYPE_TEXT, '2', '解约'), _SIGN_TYPE_TEXT);

function convertStatus(status) {
  if (STATUS_AUDITED.indexOf(status) !== -1) {
    return ITEM_STATUS.audited;
  } else if (STATUS_SUCCESS.indexOf(status) !== -1) {
    return ITEM_STATUS.success;
  } else if (STATUS_REJECT.indexOf(status) !== -1) {
    return ITEM_STATUS.reject;
  } else if (STATUS_UNSIGN.indexOf(status) !== -1) {
    return ITEM_STATUS.unsign;
  } else {
    return '';
  }
}

function convertSignType(type) {
  return SIGN_TYPE_TEXT[String(type)] ? SIGN_TYPE_TEXT[String(type)] : '';
}

function convertChannelStatus(status) {
  return STATUS[String(status)] ? STATUS[String(status)] : '';
}



/***/ }),

/***/ 17:
/***/ (function(module, exports) {

module.exports = require("core-js/modules/es.array.index-of");

/***/ })

/******/ });